import React, {useContext, useEffect, useCallback, useRef} from 'react';
import {Link} from 'react-router-dom';
import {Splide, SplideSlide} from '@splidejs/react-splide';
import Plyr from 'plyr-react'
import PrismaZoom from 'react-prismazoom';

import {ContextAuth} from '../../../common/context/context-auth';

import GlobalConst from '../../../common/global-const';
import {useToast} from '../../../common/hook/toast';

import SocialNetworks from '../../../common/component/SocialNetworks/SocialNetworks';

import {Container, Row, Col, Button, Nav} from 'react-bootstrap';

import {ReactComponent as ImgTicket} from '../../../asset/img/icon/ticket.svg';
import * as IconFi from 'react-icons/fi';

const Place1 = props => {
    const auth = useContext(ContextAuth)
    const {callToast} = useToast()
    const refPrismaZoom = useRef();
    // const refHasTicket = useRef(['1', '4']);
    const refHasTicket = useRef([]);

    const data = props.data

    // ---------------------------------------------------------------------------------------------------------- splide

    const slideshowOptions = {...GlobalConst.splide, padding: 0,
        breakpoints: {
            576: {
                padding: '1.25rem'
            }
        }
    }

    // ------------------------------------------------------------------------------------------------------------ plyr

    const videoRef = useCallback(node => {
        if (node !== null && node.plyr.toggleControls) {
            node.plyr.toggleControls(false);
            node.plyr.on('play', () => node.plyr.config.hideControls = true);
        }
    }, []);

    // ------------------------------------------------------------------------------------------------------------- map

    useEffect(() => {

        let timeout = setTimeout(() => {

            let $prismaZoom = document.querySelector('#pagePlace .prisma-zoom');
            let $path = $prismaZoom.querySelector(`svg path#path${data.shop.shopNumber}`);

            if ($path) {
                const x = $path.getBoundingClientRect().left - $prismaZoom.getBoundingClientRect().left
                const y = $path.getBoundingClientRect().top - $prismaZoom.getBoundingClientRect().top
                const width = $path.getBoundingClientRect().width
                const height = $path.getBoundingClientRect().height

                refPrismaZoom.current.zoomToZone(x, y, width, height)
            }

        }, 1000)

        return () => clearTimeout(timeout)

    }, [])

    const zoomIn = () => {
        refPrismaZoom.current.zoomIn(1)
    }

    const zoomOut = () => {
        refPrismaZoom.current.zoomOut(1)
    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <section id="banner" className="position-relative">
                <div className="position-absolute top-0 end-0 bottom-0 start-0 bg-primary bg-opacity-12 z-index-n1">
                    <picture className="d-block mx-auto h-100 filter-warm">
                        <span className="filter-level"/>
                        <source media="(max-width:767px)" srcSet={`${GlobalConst.cdn}${data.page.coverV?.path}`}/>
                        <img src={`${GlobalConst.cdn}${data.page.coverH?.path}`} alt="" className="h-100 w-100 object-fit-cover"/>
                        <span className="filter-gradient"/>
                    </picture>
                </div>
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="d-flex flex-column align-items-center mt-5 pt-5 pb-4">
                            <h1 className="mt-5 mb-4 pt-5 display-2 fw-bold ls-1 ws-n1">{data.entertainmentPlace.name}</h1>
                            {
                                (data.entertainmentPlace.workHour[0] || data.entertainmentPlace.workHour[1]) && (
                                    <>
                                        <span className="mb-lg-3 fs-8">ساعـات کار</span>
                                        <p className="d-flex flex-column align-items-center mb-2 mt-1 working-hours">
                                            {
                                                data.entertainmentPlace.workHour[0] && (
                                                    <span className="fs-5 lh-1" dangerouslySetInnerHTML={{__html: data.entertainmentPlace.workHour[0].includes('-') ? data.entertainmentPlace.workHour[0].replace('-','<span>تا</span>') : data.entertainmentPlace.workHour[0]}}/>
                                                )
                                            }
                                            {
                                                data.entertainmentPlace.workHour[1] && (
                                                    <span className="fs-5 lh-1" dangerouslySetInnerHTML={{__html: data.entertainmentPlace.workHour[1].includes('-') ? data.entertainmentPlace.workHour[1].replace('-','<span>تا</span>') : data.entertainmentPlace.workHour[1]}}/>
                                                )
                                            }
                                        </p>
                                    </>
                                )
                            }
                            <span className="fs-5 ls-half">طبقه {data.floor.title} غرفه <span className="ls-1 font-fa">{data.shop.shopNumber}</span></span>
                            <Button href={`tel:+98${data.page.contactUs[0]}`} variant="link" className="flex-column align-items-center text-center p-0 text-reset text-decoration-none mt-4">
                                <span className="bg-primary bg-opacity-60 p-1 mb-2 rounded-square">
                                    <IconFi.FiPhone size={24} className="sw-1 m-2 flip-h"/>
                                </span>
                                <span className="fw-normal lh-sm fs-9">تـمـاس</span>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Container id="box" fluid="lg" as="section">
                <Row className="g-0">
                    <Col lg={7} id="map">
                        <div className="ratio ratio-7x5 bg-secondary overflow-hidden position-relative h-100">
                            <style dangerouslySetInnerHTML={{__html: `#pagePlace .prisma-zoom svg path#path${data.shop.shopNumber} {fill: #ffffff !important}`}}/>
                            <PrismaZoom className="d-flex justify-content-center align-items-center prisma-zoom" ref={refPrismaZoom} allowTouchEvents maxZoom={3}>
                                <div dangerouslySetInnerHTML={{__html: data.map}}/>
                            </PrismaZoom>
                            <div className="d-flex flex-column shadow-sm border-top border-black-3 bg-white position-absolute start-0 bottom-0 z-index-1 zoom">
                                <Button variant="link" className="text-secondary btn-icon" onClick={zoomIn}><IconFi.FiPlus size={24} className="sw-1"/></Button>
                                <hr className="my-0"/>
                                <Button variant="link" className="text-secondary btn-icon" onClick={zoomOut}><IconFi.FiMinus size={24} className="sw-1"/></Button>
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className="p-5 order-first order-lg-0 bg-primary bg-opacity-12">
                        <p className="mb-0" dangerouslySetInnerHTML={{__html: data.page.description}}/>
                        {
                            data.page.networkAddresses.length && (
                                <Nav className="mx-n2 mt-3 lh-1">
                                    <SocialNetworks data={data.page.networkAddresses}/>
                                </Nav>
                            )
                        }
                    </Col>
                    <Col md={6} id="video">
                        <div className={`ratio ratio-4x3 bg-accent overflow-hidden${data.page.video ? '' : ' blank'}`}>
                            {
                                data.page.video ? (
                                    <Plyr source={{type: 'video', sources: [{src: `${GlobalConst.cdn}${data.page.video?.path}`, type: 'video/mp4'}], poster: `${GlobalConst.cdn}${data.page.videoCover?.path}`}} options={GlobalConst.plyr} ref={videoRef}/>
                                ) : (
                                    <div className="text-primary px-5 py-4 text-center d-flex align-items-center justify-content-center fs-5 h-100 ws-n1">در حال حاضر ویدیویی وجود ندارد</div>
                                )
                            }
                        </div>
                    </Col>
                    <Col md={6} className="gallery">
                        <div className={`ratio ratio-4x3 ${data.page.photos.length ? '' : ' blank'}`}>
                            {
                                data.page.photos.length ? (
                                    <div className="bg-primary bg-opacity-38 slideshow">
                                        <Splide options={slideshowOptions}>
                                            {
                                                data.page.photos.map(item => {
                                                    return (
                                                        <SplideSlide className="position-relative" key={item.id}>
                                                            <figure className="mb-0 position-absolute top-0 end-0 bottom-0 start-0 mx-2 mx-sm-0 filter-warm">
                                                                <span className="filter-level"/>
                                                                <img src={`${GlobalConst.cdn}${item.path}`} alt="" className="w-100 h-100 object-fit-cover"/>
                                                            </figure>
                                                        </SplideSlide>
                                                    )
                                                })
                                            }
                                        </Splide>
                                    </div>
                                ) : (
                                    <div className="bg-accent-2 px-5 py-4 text-center d-flex align-items-center justify-content-center fs-5 h-100 ws-n1 text-primary">در حال حاضر گالری وجود ندارد</div>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container as="section" fluid="lg" className="page-footer">
                <Row>
                    <Col xs={12} className="py-2 d-grid">
                        {
                            refHasTicket.current.includes(data.entertainmentPlace.id) && (
                                auth.user ? (
                                    <Button as={Link} to={`/entertain/ticket-order/${data.entertainmentPlace.id}`} className="my-1"><ImgTicket className="sw-1 me-2"/>{GlobalConst.buyTicketOnline}</Button>
                                ) : (
                                    <Button className="my-1" onClick={() => callToast('secondary', null, null, GlobalConst.loginFirst)}><ImgTicket className="sw-1 me-2"/>{GlobalConst.buyTicketOnline}</Button>
                                )
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Place1;